import React from 'react';
import { palette } from '../../styles/theme';

export function TransactionsPositionSVG ({ customStroke, className = '', selected = false }) {
    const stroke = customStroke || palette.icons;

    return (
        <span className={className}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                width="24px"
                viewBox="0 0 24 24"
                fill="none"
            >
                <g clipPath="url(#clip0)">
                    <path
                        d="M20 11C19.7554 9.24038 18.939 7.60996 17.6766 6.35989C16.4143 5.10982 14.776 4.30944 13.014 4.08203C11.4405 3.87727 9.84148 4.13948 8.41576 4.83607C6.99005 5.53266 5.80051 6.6329 4.995 8.00003"
                        stroke={stroke}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M4 13C4.23134 14.6651 4.97504 16.217 6.12797 17.4404C7.2809 18.6639 8.78594 19.4983 10.4344 19.828C12.0829 20.1577 13.793 19.9663 15.3279 19.2804C16.8627 18.5945 18.146 17.448 19 16"
                        stroke={stroke}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M18 16C18 16.2652 18.1054 16.5196 18.2929 16.7071C18.4804 16.8946 18.7348 17 19 17C19.2652 17 19.5196 16.8946 19.7071 16.7071C19.8946 16.5196 20 16.2652 20 16C20 15.7348 19.8946 15.4804 19.7071 15.2929C19.5196 15.1054 19.2652 15 19 15C18.7348 15 18.4804 15.1054 18.2929 15.2929C18.1054 15.4804 18 15.7348 18 16Z"
                        stroke={stroke}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M4 8C4 8.26522 4.10536 8.51957 4.29289 8.70711C4.48043 8.89464 4.73478 9 5 9C5.26522 9 5.51957 8.89464 5.70711 8.70711C5.89464 8.51957 6 8.26522 6 8C6 7.73478 5.89464 7.48043 5.70711 7.29289C5.51957 7.10536 5.26522 7 5 7C4.73478 7 4.48043 7.10536 4.29289 7.29289C4.10536 7.48043 4 7.73478 4 8Z"
                        stroke={stroke}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <g clipPath="url(#clip1)">
                        <path
                            d="M14.3502 10C14.2507 9.71762 14.0689 9.47148 13.8283 9.29327C13.5877 9.11505 13.2993 9.01292 13.0002 9H11.0002C10.6024 9 10.2208 9.15804 9.93952 9.43934C9.65822 9.72064 9.50018 10.1022 9.50018 10.5C9.50018 10.8978 9.65822 11.2794 9.93952 11.5607C10.2208 11.842 10.6024 12 11.0002 12H13.0002C13.398 12 13.7795 12.158 14.0608 12.4393C14.3421 12.7206 14.5002 13.1022 14.5002 13.5C14.5002 13.8978 14.3421 14.2794 14.0608 14.5607C13.7795 14.842 13.398 15 13.0002 15H11.0002C10.7011 14.9871 10.4126 14.8849 10.172 14.7067C9.93146 14.5285 9.74971 14.2824 9.65018 14"
                            stroke={stroke}
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M12 7.5V9M12 15V16.5"
                            stroke={stroke}
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                    <clipPath id="clip1">
                        <rect width="12" height="12" fill="white" transform="translate(6 6)" />
                    </clipPath>
                </defs>
            </svg>
        </span>
    );
};
